import { useCallback } from 'react';

import NavigationLinkImpressionEvent from '~/events/NavigationLinkImpressionEvent';
import type { NavigationLinkPlacement } from '~/events/NavigationLinkInteractionEvent';
import useImpression from '~/hooks/useImpression';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

type Options = {
  href: string;
  label?: string;
  placement: NavigationLinkPlacement;
  position: number;
};

export default function useNavigationLinkImpression<T extends HTMLElement>({
  href,
  label,
  placement,
  position
}: Options) {
  const { isBot } = useRootData();
  const { guestId } = useUser();

  const track = useCallback(() => {
    new NavigationLinkImpressionEvent({
      guestId,
      href,
      isBot,
      label,
      placement,
      position
    }).track();
  }, [guestId, href, isBot, label, placement, position]);

  return useImpression<T>(track, { enabled: !isBot });
}
